import { LogType } from '../types/visualizer';
import { InteractionProcessor } from './interaction-log-processor';
import { FlowLogProcessor } from './flow-log-processor';
import { BaseLogProcessor } from './base-log-processor';
import { type InteractionLogsObject } from '../types/interaction-log-data';
import { type FlowLogsObject } from '../types/flow-log';

export type LogDataType = InteractionLogsObject | FlowLogsObject;

export class ProcessorFactory {
  private static interactionProcessor: InteractionProcessor | null = null;
  private static flowLogProcessor: FlowLogProcessor | null = null;

  public static getProcessor(logType: LogType): BaseLogProcessor<unknown, unknown> {
    switch (logType) {
      case LogType.INTERACTION_LOG:
        if (!this.interactionProcessor) {
          this.interactionProcessor = new InteractionProcessor();
        }
        // Always clear the processor before returning to ensure clean state
        this.interactionProcessor.clear();
        return this.interactionProcessor;

      case LogType.FLOW_LOG:
        if (!this.flowLogProcessor) {
          this.flowLogProcessor = new FlowLogProcessor();
        }
        // Always clear the processor before returning to ensure clean state
        this.flowLogProcessor.clear();
        return this.flowLogProcessor;

      default:
        throw new Error(`Unsupported log type: ${logType}`);
    }
  }

  public static clearProcessors(): void {
    this.interactionProcessor?.clear();
    this.flowLogProcessor?.clear();
  }
}
